/**
 * 告警默认展示3条
 */
export const DEFAULT_QUANTITY = 3;
